import { render, staticRenderFns } from "./DashboardCardBarChart.vue?vue&type=template&id=74b54d3c&"
import script from "./DashboardCardBarChart.vue?vue&type=script&lang=ts&"
export * from "./DashboardCardBarChart.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardCardBarChart.vue?vue&type=style&index=0&id=74b54d3c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports